import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiFilter } = FiIcons;

const CategoryFilter = ({ categories, selectedCategory, onSelectCategory }) => {
  return (
    <div className="relative">
      <div className="flex items-center space-x-2">
        <SafeIcon icon={FiFilter} className="text-gray-500" />
        <select
          value={selectedCategory}
          onChange={(e) => onSelectCategory(e.target.value)}
          className="block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 rounded-md"
        >
          {categories.map((category, index) => (
            <option key={index} value={category}>
              {category}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default CategoryFilter;